import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, NgForm, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MasterService } from "src/app/services/master.service";

@Component({
  selector: "app-secure-email-sms",
  templateUrl: "./email-sms.component.html",
  styleUrls: ["./email-sms.component.scss"],
})
export class EmailSmsComponent implements OnInit {
  selectedFile: File;
  showDataHere: any = "";
  isLoading = false;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  buttonDisabled: boolean = false;
  reports: { [key: number]: string };
  @ViewChild("localForm") localForm: NgForm;
  sms: string;
  email: string;
  notification: string;
  emailSmsBody: string;
  subject: String;
  finalmessage: String;
  // showDataHere:String;

  constructor(
    private router: Router,
    private masterService: MasterService,
    private _snackBar: MatSnackBar
  ) {}
  ngOnInit(): void {
    this.form = new FormGroup({
      emailSmsBody: new FormControl(null, Validators.required),
      subject: new FormControl(null, Validators.required),
      email: new FormControl(),
      sms: new FormControl(),
      notification: new FormControl(),
      finalmessage: new FormControl(),
      showDataHere: new FormControl(),
      file: new FormControl(),
      csvcolume: new FormControl(),
    });
  }

  onFileSelect(event) {
    this.selectedFile = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsText(this.selectedFile);

    reader.onload = (e) => {
      let csv: string = reader.result as string;
      let allTextLines = csv.split(/\r|\n|\r/);
      let headers = allTextLines[0].split(",");
      let lines = [];

      for (let i = 0; i < allTextLines.length; i++) {
        // split content based on comma
        let data = allTextLines[i].split(",");

        if (data.length === headers.length) {
          let tarr = [];
          for (let j = 0; j < headers.length; j++) {
            tarr.push(data[j]);
          }

          // log each row to see output
          console.log(tarr);
          lines.push(tarr);
        }
      }

      this.showDataHere = lines[0].join("\n");
      if (
        this.showDataHere.includes("Application No") ||
        this.showDataHere.includes("Pan No")
      ) {
        this.showDataHere;
      } else {
        this.errorToast(
          "Application No OR Pan No will be Compulsory in CSV file"
        );
        this.localForm.resetForm({
          file: null,
        });
        this.selectedFile = null;
        this.showDataHere = null;
      }
    };
  }
  onCheckboxChangeEmail(e: any) {
    if (e.target) {
    }
  }
  onCheckboxChangeSms(e: any) {
    if (e.target) {
    }
  }

  onCheckboxChangeNotification(e: any) {
    if (e.target) {
    }
  }

  showPreview() {
    if (this.selectedFile) {
      console.log(this.form.value.emailSmsBody);
      const reader = new FileReader();
      reader.readAsDataURL(this.selectedFile);
      reader.onload = () => {
        this.masterService
          .bulkEmailSmsResults(
            this.form.value.subject,
            this.form.value.emailSmsBody,
            this.form.value.notification,
            this.form.value.email,
            this.form.value.sms,
            reader.result,
            this.selectedFile.name.substring(
              0,
              this.selectedFile.name.indexOf(".")
            )
          )
          .subscribe(
            (data: any) => {
              console.log("data", data);
              if (data.status === "SUCCESS") {
                this.form.patchValue({
                  finalmessage: data.tempMessage,
                });

                this.successToast();
              } else {
                this.isSubmitDisabled = false;
                this.errorToast(data.errorMessage);
              }
            },
            (error) => {
              this.isSubmitDisabled = false;
              console.log(error);
              this.errorToast(error.error.errorMessage, 5 * 1000);
            }
          );
      };
    } else {
      this.masterService.errorToast("Please upload file ");
    }
  }

  async successToast() {
    await this._snackBar.open("final Message.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }
  async successOnsubmitToast() {
    await this._snackBar.open("Job Excution Start", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }
  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }
  onSubmit() {
    console.log(this.selectedFile);

    if (this.selectedFile) {
      if (this.form.value.emailSmsBody) {
        if (
          this.form.value.email ||
          this.form.value.sms ||
          this.form.value.notification
        ) {
          this.isLoading = true;
          const reader = new FileReader();
          reader.readAsDataURL(this.selectedFile);
          reader.onload = () => {
            this.masterService
              .finalBulkEmailSmsResults(
                this.form.value.subject,
                this.form.value.emailSmsBody,
                this.form.value.notification,
                this.form.value.email,
                this.form.value.sms,
                reader.result,
                this.selectedFile.name.substring(
                  0,
                  this.selectedFile.name.indexOf(".")
                )
              )
              .subscribe(
                (data: any) => {
                  this.isSubmitDisabled = false;
                  if (data.status === "SUCCESS") {
                    this.isLoading = true;
                    this.successOnsubmitToast();
                    this.localForm.resetForm({
                      file: null,
                    });
                    this.selectedFile = null;
                    this.showDataHere = null;
                    // window.onload;
                    location.reload();
                  } else {
                    this.isLoading = true;
                    this.localForm.resetForm({
                      file: null,
                    });
                    this.selectedFile = null;
                    this.masterService.errorToast(data.errorMessage);
                  }
                },
                (error) => {
                  this.isLoading = false;
                  this.localForm.resetForm({
                    file: null,
                  });
                  this.selectedFile = null;
                  this.showDataHere = null;
                  this.isSubmitDisabled = false;
                  console.log(error);

                  this.masterService.errorToast(
                    error?.error?.message || error?.error?.errorMessage,
                    5 * 1000
                  );
                }
              );
          };
        } else {
          this.masterService.errorToast("Please Select AtLeast One Check Box");
        }
      } else {
        this.masterService.errorToast("Please Enter Message");
      }
    } else {
      this.masterService.errorToast("Please upload file ");
    }
    // }
    // else {
    //   this.isSubmitDisabled = false;
    // }
  }
  // downloadEmailSmsTemplate() {
  //   this.importMasterService
  //     .downloadEmailSmsTemplate()
  //     .subscribe((data: any) => {
  //       if (data.status === "SUCCESS") {
  //         this.downloadFile(data.data, "EMAILSMS.csv");
  //       } else {
  //         this.importMasterService.errorToast(data.errorMessage);
  //       }
  //     });
  // }

  // downloadFile(base64: string | ArrayBuffer, fileName: string) {
  //   const src = `data:text/csv;base64,${base64}`;
  //   const link = document.createElement("a");
  //   link.href = src;
  //   link.download = fileName;
  //   link.click();

  //   link.remove();
  // }
}
